export default (key: string) => ({
  _storageKey: `beskar:draft:${key}`,
  _interval: null as ReturnType<typeof setInterval> | null,
  showRestoreBanner: false,
  _savedAt: null as string | null,

  init() {
    const saved = localStorage.getItem(this._storageKey);
    if (saved) {
      try {
        const parsed = JSON.parse(saved) as { savedAt?: string, title: string, content: string };
        this._savedAt = parsed.savedAt ?? null;
        if(parsed.title !== "" && parsed.content !== "") {
          this.showRestoreBanner = true;
        }
      } catch {
        localStorage.removeItem(this._storageKey);
      }
    }

    this._interval = setInterval(() => { this._save(); }, 30000);

    const form = this.$el.tagName === "FORM"
      ? this.$el as HTMLFormElement
      : this.$el.querySelector<HTMLFormElement>("form");
    if (form) {
      form.addEventListener("submit", () => {
        localStorage.removeItem(this._storageKey);
        if (this._interval) clearInterval(this._interval);
      });
    }
  },

  _save() {
    const titleEl = (document.getElementById("post_name")
      ?? document.getElementById("bookmark-name")) as HTMLInputElement | null;
    const slugEl = document.querySelector<HTMLInputElement>('[name$="[slug]"]');
    const tagsEl = document.querySelector<HTMLInputElement>('[name$="[tags]"]');
    const contentEl = (document.getElementById("post_content")
      ?? document.getElementById("bookmark_content")) as HTMLInputElement | null;

    localStorage.setItem(this._storageKey, JSON.stringify({
      title: titleEl?.value ?? "",
      slug: slugEl?.value ?? "",
      tags: tagsEl?.value ?? "",
      content: contentEl?.value ?? "",
      savedAt: new Date().toISOString(),
    }));
  },

  restore() {
    const saved = localStorage.getItem(this._storageKey);
    if (!saved) return;
    try {
      const { title, slug, tags, content } = JSON.parse(saved) as {
        title?: string; slug?: string; tags?: string; content?: string;
      };
      const titleEl = (document.getElementById("post_name")
        ?? document.getElementById("bookmark-name")) as HTMLInputElement | null;
      const slugEl = document.querySelector<HTMLInputElement>('[name$="[slug]"]');
      const tagsEl = document.querySelector<HTMLInputElement>('[name$="[tags]"]');
      const contentEl = (document.getElementById("post_content")
        ?? document.getElementById("bookmark_content")) as HTMLInputElement | null;

      if (titleEl && title) {
        titleEl.value = title;
        titleEl.dispatchEvent(new Event("change"));
      }
      if (slugEl && slug) slugEl.value = slug;
      if (tagsEl && tags) tagsEl.value = tags;
      if (content) {
        if (contentEl) contentEl.value = content;
        document.dispatchEvent(new CustomEvent("tiptap:set-content", { detail: { content } }));
      }
    } catch {
      // ignore corrupt data
    }
    localStorage.removeItem(this._storageKey);
    this.showRestoreBanner = false;
  },

  dismiss() {
    localStorage.removeItem(this._storageKey);
    this.showRestoreBanner = false;
  },

  get savedAtFormatted() {
    if (!this._savedAt) return "";
    try {
      return new Date(this._savedAt).toLocaleString();
    } catch {
      return this._savedAt;
    }
  },
});
